// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__28ZFJ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2YrPj","obliqueLine":"membershipbadge_obliqueLine__1Xa6o"};